import { render, staticRenderFns } from "./CobrosComponent.vue?vue&type=template&id=6a9bb06c&"
import script from "./CobrosComponent.vue?vue&type=script&lang=js&"
export * from "./CobrosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports